'use strict'

import Vue from 'vue'
import AppConfig from '@/config'
import { EventBus } from '@/modules/event-bus'

const state = {
  token: null,
  userId: null,
  userNm: null,
  userStatus: null,
  userTypeCd: null,
  btnAuth: null,
  authList: []
}

const getters = {
  getToken (state) {
    return state.token
  },
  getUserId (state) {
    return state.userId
  },
  getUserNm (state) {
    return state.userNm
  },
  getUserStatus (state) {
    return state.userStatus
  },
  getUserTypeCd (state) {
    return state.userTypeCd
  },
  getBtnAuth (state) {
    return state.btnAuth
  },
  getAuthList (state) {
    return state.authList
  }
}

const mutations = {
  setToken (state, { token }) {
    state.token = token
  },
  setUserId (state, { userId }) {
    state.userId = userId
  },
  setUserNm (state, { userNm }) {
    state.userNm = userNm
  },
  setUserStatus (state, { userStatus }) {
    state.userStatus = userStatus
  },
  setUserTypeCd (state, { userTypeCd }) {
    state.userTypeCd = userTypeCd
  },
  setBtnAuth (state, { btnAuth }) {
    state.btnAuth = btnAuth
  },
  setAuthList (state, { authList }) {
    state.authList = authList
  }
}

const actions = {
  abcFunc: (param) => {
    console.log('>>>> > file: Login.js > line 67 > param', param)
  },
  login ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post('/app/login', params)
        .then(response => {
          if (response.data.result) {
            commit('setToken', { token: response.headers['x-auth-token'] })
            commit('setUserId', { userId: response.data.result.userId })
            commit('setUserNm', { userNm: response.data.result.userNm })
            commit('setUserStatus', { userStatus: response.data.result.userStatus })
            commit('setUserTypeCd', { userTypeCd: response.data.result.userTypeCd })
            commit('setAuthList', { authList: response.data.result.authList })

            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token']
            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

            const { data: { result: { autoLoginToken } } } = response

            if (window && autoLoginToken) {
              window.localStorage.setItem('autoLoginToken', autoLoginToken)
            }
          }
          resolve(response.data.result)
        })
        .catch(e => reject(e))
    })
  },
  loginByToken ({ commit, state }, token) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post('/app/loginByToken', {userUuid: token})
        .then(response => {
          if (response.data.result) {
            commit('setToken', { token: response.headers['x-auth-token'] })
            commit('setUserId', { userId: response.data.result.userId })
            commit('setUserNm', { userNm: response.data.result.userNm })
            commit('setUserStatus', { userStatus: response.data.result.userStatus })
            commit('setUserTypeCd', { userTypeCd: response.data.result.userTypeCd })
            commit('setAuthList', { authList: response.data.result.authList })

            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token']
            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

            const { data: { result: { autoLoginToken } } } = response

            if (window && autoLoginToken) {
              window.localStorage.setItem('autoLoginToken', autoLoginToken)
            }
          }
          resolve(response.data.result)
        })
        .catch(e => reject(e))
    })
  },
  logout ({ commit, state, rootGetters }, forceOut) {
    return new Promise((resolve, reject) => {
      const checkJobDone = async () => {
        const bosCollectCnt = rootGetters['AtmWsStore/getBosCollectCnt']
        const workCollectCnt = rootGetters['AtmWsStore/getWorkCollectCnt']

        if (!forceOut && bosCollectCnt > workCollectCnt) {
          await window.$Alert.alert('ATM 내 회수해야 할 단말이 남아있습니다.')
        }

        window.$store.dispatch('AtmWsStore/jobEndNoticeToAtm', true)
      }
      const disp_func = () => {
        Vue.httpClient
          .post('/app/logout', {})
          .then(response => {
            if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              commit('setToken', { token: null })
              commit('setUserId', { userId: null })
              commit('setUserNm', { userNm: null })
              commit('setUserStatus', { userStatus: null })
              commit('setUserTypeCd', { userTypeCd: null })
              commit('setAuthList', { authList: [] })

              Vue.httpClient.defaults.headers.common['x-auth-token'] = null
              Vue.$sessionStorage.clear()

              window.$store.dispatch('LatestMenu/clearLatestMenu')

              EventBus.$emit('event-logout')
            }
            resolve()
          })
          .catch(e => reject(e))
      }
      if (forceOut) {
        checkJobDone()
        disp_func()
      } else {
        window.$Alert.confirm('로그아웃 하시겠습니까?').then(async (res) => {
          if (res) {
            await checkJobDone()
            disp_func()
          }
        })
      }
    })
  },
  isLogin ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.token) {
        resolve()
      } else {
        Vue.httpClient.defaults.headers.common['x-auth-token'] = Vue.$sessionStorage.get('xAuthToken')

        Vue.httpClient
          .post('/app/login/check', {})
          .then(response => {
            if (response.data.result && response.data.result.isLogin) {
              commit('setToken', { token: response.headers['x-auth-token'] })
              commit('setUserId', { userId: response.data.result.userId })
              commit('setUserNm', { userNm: response.data.result.userNm })
              commit('setUserStatus', { userStatus: response.data.result.userStatus })
              commit('setUserTypeCd', { userTypeCd: response.data.result.userTypeCd })
              commit('setAuthList', { authList: response.data.result.authList })

              Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token']
              Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

              resolve()
            } else {
              reject()
            }
          })
          .catch(e => reject(e))
      }
    })
      .then(function () {
        return true
      }).catch(function () {
        return false
      })
  },
  checkAuth ({ commit, state }, params) {
    Vue.httpClient.defaults.headers.common['x-auth-token'] = Vue.$sessionStorage.get('xAuthToken')
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post('/app/login/checkAuth', params)
        .then(response => {
          if (response.data.result.checkAuth) {
            resolve()
          } else {
            reject()
          }
        })
        .catch(e => reject(e))
    })
      .then(function () {
        return true
      }).catch(function () {
        return false
      })
  },
  btnAuth ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .get('/app/login/getBtnAuth', {params: {urlPath: params.path}})
        .then(response => {
          if (response.data.result) {
            commit('setBtnAuth', {
              btnAuth: response.data.result
            })
          }
          resolve()
        })
        .catch(e => reject(e))
    })
  },
  refreshLogin ({ commit, state }) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post('/app/login/check', {})
        .then(response => {
          if (response.data.result && response.data.result.isLogin) {
            commit('setToken', { token: response.headers['x-auth-token'] })
            commit('setUserId', { userId: response.data.result.userId })
            commit('setUserNm', { userNm: response.data.result.userNm })
            commit('setUserStatus', { userStatus: response.data.result.userStatus })
            commit('setUserTypeCd', { userTypeCd: response.data.result.userTypeCd })
            commit('setAuthList', { authList: response.data.result.authList })

            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token']
            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

            resolve()
          } else {
            reject()
          }
        })
        .catch(e => reject(e))
    })
      .then(function () {
        return true
      }).catch(function () {
        return false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/modules/Login.js